import React from 'react';
import Button from 'component/button.component';
import { toast } from 'react-toastify';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import googleLogo from 'resource/img/google.png';
import history from 'config/history';
import { USER_LOGIN_SUCCESS, USER_LOGIN_ERROR } from 'config/constants';
import fbLogo from 'resource/img/facebook.png';
import { userLogin } from 'store/action/user.action';

export default function SocialAccess() {
  const _userLogin = user => {
    userLogin(user)
      .then(({ type, message }) => {
        if (type === USER_LOGIN_SUCCESS) {
          toast.success('Login realizado com sucesso!');
          setTimeout(() => {
            window.location.href = '/';
          }, 1000);
        } else if (type === USER_LOGIN_ERROR) {
          toast.error(message);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        toast.error('Usuário e/ou senha incorretos!');
      });
  };

  const responseFacebook = res => {
    const { email, id, picture, name } = res;
    const image = picture.data ? picture.data.url : null;
    _userLogin({
      type: 'FACEBOOK',
      login: email,
      provider_token: id,
      image,
      name,
    });
  };

  const responseGoogle = response => {
    const {
      profileObj: { email, googleId, imageUrl, name },
    } = response;
    _userLogin({
      type: 'GOOGLE',
      login: email,
      provider_token: googleId,
      image: imageUrl,
      name,
    });
  };

  const responseProviderError = response => {
    toast.error('Não foi possível realizar o login. Tente novamente!');
    console.error(response);
  };

  return (
    <>
      <div
        className="row"
        style={{ justifyContent: 'center', marginBottom: '20px' }}
      >
        <div style={{ padding: '10px' }}>
          <GoogleLogin
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            render={renderProps => (
              <Button
                image={googleLogo}
                onClick={renderProps.onClick}
                text="Continue com Google"
                style={{
                  color: 'rgba(0, 0, 0, 0.54)',
                  boxShadow: '0 1px 10px rgba(0,0,0,0.2)',
                  marginLeft: 0,
                  width: '250px',
                }}
              />
            )}
            onFailure={responseProviderError}
            onSuccess={responseGoogle}
          />
        </div>
        {/* <div style={{ padding: '10px' }}>
          <FacebookLogin
            appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
            fields="name,email,picture"
            callback={responseFacebook}
            onFailure={responseProviderError}
            render={renderProps => (
              <Button
                image={fbLogo}
                text="Continue com Facebook"
                onClick={renderProps.onClick}
                style={{
                  boxShadow: '0 1px 10px rgba(0,0,0,0.2)',
                  backgroundColor: '#4267B2',
                  marginLeft: 0,
                  padding: '10px',
                  width: '250px',
                }}
              />
            )}
          />
        </div> */}
      </div>

      <div
        className="flex-row justify-between align-center"
        style={{ margin: '20px 0' }}
      >
        <span
          style={{
            flex: 1,
            borderBottom: '1px solid #E0E0E0',
            marginTop: '3px',
          }}
        />
        <p
          style={{
            color: '#707070',
            margin: '1px 20px 0',
          }}
        >
          <b>ou</b>
        </p>
        <span
          style={{
            flex: 1,
            borderBottom: '1px solid #E0E0E0',
            marginTop: '3px',
          }}
        />
      </div>
    </>
  );
}
